/**
 * Shared analytics events that are common across multiple views
 */
export const SHARED_EVENTS = {
  LOADED: "Loaded",
  ERROR: "Error",
  EMPTY_STATE: "Empty State",
} as const
